import { useTranslation } from '@mypoz/i18n';
import { cn } from '@mypoz/ui';

/** The two lists under 账户明细, as on the old website (MYP-146). */
export type AccountDetailsTab = 'transactions' | 'topUps';

const TABS: readonly AccountDetailsTab[] = ['transactions', 'topUps'];

export interface AccountDetailsHeaderProps {
  tab: AccountDetailsTab;
  onTab: (tab: AccountDetailsTab) => void;
}

/**
 * The 账户明细 heading and its tabs — 所有交易 (every movement of money) and 充值记录 (every top-up
 * attempt) — drawn at the top of whichever list is open. The old website's third tab, 返利明细
 * (rebates), is not built: MYP-146 is the transactions list only.
 *
 * Tabs in the same underline style as the Packages and Orders lists.
 */
export function AccountDetailsHeader({ tab, onTab }: AccountDetailsHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="border-b border-line px-5 pt-4 sm:px-6">
      <h2 className="text-base font-semibold text-ink">{t('wallet.details.title')}</h2>
      <div
        role="group"
        aria-label={t('wallet.details.title')}
        className="mt-3 flex gap-6 overflow-x-auto"
      >
        {TABS.map((item) => {
          const active = item === tab;
          return (
            <button
              key={item}
              type="button"
              aria-pressed={active}
              onClick={() => onTab(item)}
              className={cn(
                'min-h-11 shrink-0 border-b-2 pb-2.5 text-sm whitespace-nowrap transition-colors lg:min-h-0',
                'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand',
                active
                  ? 'border-brand font-semibold text-ink'
                  : 'border-transparent text-muted hover:text-ink',
              )}
            >
              {t(`wallet.details.tabs.${item}`)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
